import React from 'react';
import { components } from 'react-select';
import { OptionTypeBase } from 'react-select/src/types';
import { IndicatorProps } from 'react-select/src/components/indicators';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-icon.svg';

export const DropdownIndicator = (props: IndicatorProps<OptionTypeBase, boolean>) => {
  return (
    <div className={props.selectProps.classes.indicatorWrapper}>
      <components.DropdownIndicator {...props}>
        <ArrowDownIcon />
      </components.DropdownIndicator>
    </div>
  );
};
